<template>
  <div>
    <div class="header_container mb10">
      <h6>
        Pay {{ termProps.filter(item => { return item.type === this.selectedTermProps.type})[0].trans }}
      </h6>
    </div>
    <h4 class="--blue70">
      $ {{ selectedProductInfo ? selectedProductInfo.productAmount : '' }} {{ selectedProductInfo? selectedProductInfo.productAmountUnit : '' }},
      {{ selectedProductInfo ? selectedProductInfo.defaultProductSubTitle : '' }}
    </h4>
    <div class="mt20 mb30">
      <span class="txt_body_2">
        {{ selectedProductInfo ? selectedProductInfo.defaultProductDescription : '' }}
      </span>
    </div>
    <a
        @click="clickPayment()"
        class="btn blue btn_basics pointer no-drag"
    >
      {{$t('status.buy_now')}}
    </a>
    <div class="full_line_underline_gray mt30 mb30">
    </div>
    <div>
      <div class="txt_subtitle_2 --grey80 mb10">
        📌&nbsp;&nbsp;&nbsp;No commitment, Cancel anytime
      </div>
      <ul>
        <li class="mb10">
          <p class="txt_body_2">✔️&nbsp;&nbsp;&nbsp;Advanced Robot Device</p>
        </li>
        <li class="mb10">
          <p class="txt_body_2">✔️&nbsp;&nbsp;&nbsp;Multi-Position Application</p>
        </li>
        <li class="mb10">
          <p class="txt_body_2">✔️&nbsp;&nbsp;&nbsp;Broad Rehabilitation Coverage</p>
        </li>
        <li class="mb10">
          <p class="txt_body_2">✔️&nbsp;&nbsp;&nbsp;Measure to Exercise on a Single Device</p>
        </li>
        <li class="mb10">
          <p class="txt_body_2">✔️&nbsp;&nbsp;&nbsp;Smart Tele-Tehab Platform</p>
        </li>
        <li class="mb10">
          <p class="txt_body_2">✔️&nbsp;&nbsp;&nbsp;Diverse Exercise Modes</p>
        </li>
        <li class="mb10">
          <p class="txt_body_2">✔️&nbsp;&nbsp;&nbsp;Time & Cost Saving</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoArea',
  props: {
    selectedTermProps: Object,
    selectedProductProps: Object,
    termProps: Array,
    productProps: Array
  },
  data() {
    return {
      selectedProductInfo: this.productProps.filter(item => { return item?.seqProduct === this.selectedProductProps?.seqProduct})[0]
    }
  },
  computed: {
    computedProductInfo() {
      if (this.selectedProductInfo && this.selectedProductInfo.productPatientProfileLimit === 0) {
        return 'Unlimited';
      } else {
        return `${this.selectedProductInfo.productPatientProfileLimit} Patients`;
      }
    }
  },
  created() {
    if (this.productProps.length === 0) {
      this.$router.go(-1);
    }
  },
  methods: {
    clickPayment() {
      if (process.env.NODE_ENV === 'production' || confirm('확인 버튼을 누르면, 실제로 카드 결제가 이루어집니다. 카드 결제 취소는 sw팀 한이지 선임연구원에게 요청해주세요.')) {
        this.$emit('doPay');
      }
    }
  }
}
</script>